export default "__VITE_ASSET__CE2bLUyV__"